import { useQuery } from '@tanstack/react-query';
import { ResourceType } from 'libs.library_manager';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export function useL10nMapFetch(resourceId) {
    const { get } = useApiClient(ApiClientService.LIBRARY);
    return useQuery({
        queryKey: ['study', 'l10nmap', 'fetch', resourceId],
        queryFn: async () => {
            const response = await get(`/v1/${ResourceType.L10N_MAP}/${resourceId}`);
            return response.data?.data?.data?.mapping || {};
        },
        retry: false,
        enabled: !!resourceId,
    });
}
